import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { stringify } from 'querystring-es3';
import suitcss from '../../../helpers/suitcss';

const componentName = 'UIYoutubePlayer';
class UIYoutubePlayer extends Component {

  getFormatedUrl() {
    const { videoId, autoPlay } = this.props;
    const settings = {
      autoplay: autoPlay ? 1 : 0,
      autohide: 1,
      modestbranding: 1,
      color: 'white',
      controls: 0,
      rel: 0,
      showinfo: 0,
    };

    return `//www.youtube.com/embed/${videoId}?${stringify(settings)}`;
  }

  render() {
    const { width, height, videoId } = this.props;

    if (!videoId) {
      return null;
    }

    return (
      <div className={suitcss({ componentName })}>
        <iframe
          type="text/html"
          width={width}
          height={height}
          src={this.getFormatedUrl()}
          frameBorder="0"
        />
      </div>
    );
  }
}

UIYoutubePlayer.propTypes = {
  videoId: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  autoPlay: PropTypes.bool,
};

UIYoutubePlayer.defaultProps = {
  width: '100%',
  height: '100%',
};

export default UIYoutubePlayer;
